

export enum CompetitorsSoldOutAlertRuleInclusion {
	ALL = 'ALL', ANY = 'ANY', SOME = 'SOME'
}